import profileAwariService from '@/services/profileAwariService'
import { modalCreators } from '@/store/ducks/modal'
import { useAppDispatch } from '@/store/hooks'

export function usePlanValidation() {
	const dispatch = useAppDispatch()

	const { data: dataProfileAwari } = profileAwariService.getProfileAwari()

	const validationPlan = ({ messageCredits }: { messageCredits?: string }) => {
		const userIsAwari = !!dataProfileAwari

		if (!userIsAwari) {
			dispatch(
				modalCreators.openModal({
					name: 'statusModal',
					type: 'error',
					modalInfo: {
						title: 'Plano Indisponível',
						buttonLabel: 'Fechar',
						message:
							'Seu plano atual não permite o agendamento de mentorias com este(a) mentor(a).',
					},
				})
			)
			return true
		}

		if (
			messageCredits &&
			(!dataProfileAwari?.balance || dataProfileAwari?.balance === 0)
		) {
			dispatch(
				modalCreators.openModal({
					name: 'statusModal',
					type: 'error',
					modalInfo: {
						title: 'Crédito Insuficiente',
						buttonLabel: 'Fechar',
						message: messageCredits || 'Você precisa ter créditos.',
					},
				})
			)
			return true
		}

		return false
	}

	return {
		validationPlan,
		isLeadAwari: !!dataProfileAwari,
	}
}
